import { CandidateFlow } from "@/shell/CandidateFlow";
import { Card } from "@/components/primitives";

// Shared terminal error card (Jinja: invite_error.html).
export function InviteError({ message }: { message: string }) {
  return (
    <CandidateFlow>
      <Card className="space-y-3 text-center">
        <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full bg-[#f7e9e6] text-crit">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 8v5M12 16.5h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
          </svg>
        </span>
        <p className="text-sm text-slate-700">{message}</p>
        <p className="text-xs text-slate-400">
          Reply to the invite email you received, or contact your recruitment consultant to request a new link.
        </p>
      </Card>
    </CandidateFlow>
  );
}
